$(function() {
  'use strict';
  
  var $slick_options = {
    'prevArrow': '<button type="button" class="slick-prev"><span><i class="pe-7s-angle-left" aria-hidden="true"></i></span></button>',
    'nextArrow': '<button type="button" class="slick-next"><span><i class="pe-7s-angle-right" aria-hidden="true"></i></span></button>',
    fade: false,
    speed: 600,
    infinite: true,
    dots: false,
    autoplay: false,
    autoplaySpeed: 4000,
    pauseOnFocus: false,
    pauseOnHover: false,
    slidesToShow: 1,
    centerMode: true,
    mobileFirst: true,
    swipe: false,
    responsive: [
      {
        breakpoint: 700,
        settings: {
          slidesToShow: 2,
        }
      },
    ]
  };   

  var $slick_slider = $('.slick-container');
  $slick_slider.slick($slick_options);

  if (Foundation.MediaQuery.atLeast('large')) {
          $slick_slider.slick('unslick');
       
  }

  // reslick only if it's not slick()
  $(window).on('changed.zf.mediaquery', function(event, newSize, oldSize) {
    console.log('new size =' + newSize);
        if (newSize != 'small' && newSize != 'medium') {
          if ($slick_slider.hasClass('slick-initialized')) {
            $slick_slider.slick('unslick');
          } else {
            // $slick_slider.slick($slick_options);
          }
          return;
        }

        if (!$slick_slider.hasClass('slick-initialized')) {
          return $slick_slider.slick($slick_options);
        }
      });
  });